import { Image, Text, View } from '@react-pdf/renderer';

import { CompTypeBadge } from '../components/CompTypeBadge.tsx';
import { ImageOffLineSvg } from '../components/ImageOffLineSvg.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles, gridStyles } from '../styles.ts';
import { SalesComparablePhotosDataPageProps } from '../types.ts';

export const SalesComparablePhotosPage = ({
  subjectAddress,
  salesComparablePhotosData,
  compSequence,
}: SalesComparablePhotosDataPageProps) => (
  <>
    {salesComparablePhotosData.map((comp) => (
      <Tkv2PDFPage
        key={`pageIndex_${comp.id}`}
        title="Appendix: Sales Comparable Photos"
        address={subjectAddress}
      >
        <View>
          <View style={{ ...gridStyles.row, justifyContent: 'space-between' }}>
            <View style={[gridStyles.compactRow, { alignItems: 'center', gap: 4 }]}>
              <Text style={fontStyles.bodyBold}>
                Comparable {compSequence.indexOf(comp.id) + 1}:&nbsp;
              </Text>
              <Text style={fontStyles.body}>{comp.address}</Text>
              {comp.compType && <CompTypeBadge compType={comp.compType} />}
            </View>
            <View style={gridStyles.compactRow}>
              <Text style={fontStyles.bodyBold}>{comp.transactionText}: </Text>
              <Text style={fontStyles.body}>{comp.price?.toString(true)}</Text>
            </View>
          </View>
          {comp.photos.length > 0 ? (
            <View style={gridStyles.photoGrid}>
              {comp.photos.map((photoBlob, index) => (
                <Image
                  style={{ height: 116, width: 175 }}
                  source={photoBlob}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`photo_${index}_${comp.address}`}
                />
              ))}
            </View>
          ) : (
            <View
              style={{
                marginTop: 10,
                padding: 1,
                height: 368,
                justifyContent: 'center',
                alignItems: 'center',
                gap: 16,
                borderRadius: 10,
                border: '1px solid #EBEDEF',
                backgroundColor: '#FAFAFA',
              }}
            >
              <View
                style={{
                  width: 96,
                  height: 96,
                  borderRadius: 48,
                  backgroundColor: '#E1E4E7',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ImageOffLineSvg />
              </View>
              <Text style={{ color: '#072138', fontFamily: 'Lato-Bold', fontSize: 16 }}>
                No Photos Available
              </Text>
              <Text
                style={{
                  color: '#465C72',
                  fontFamily: 'Lato-Regular',
                  fontSize: 14,
                  lineHeight: 1.5,
                  textAlign: 'center',
                  width: 244,
                }}
              >
                There were no MLS photos available for this comparable property.
              </Text>
            </View>
          )}
        </View>
      </Tkv2PDFPage>
    ))}
  </>
);
